<template>
    <commonbody>
        <div class="chateau-details-header" slot="swiper" :style="{backgroundImage: `url(${detailsData.bg_thumbnail ?'/express_api/' + detailsData.bg_thumbnail : defaultBg})`}">
            <!-- <h2>
                <span style="font-family: serif;">{{ detailsData.title }} </span><br>
            </h2> -->
        </div>
        <div :class="['clearfix', getCommonStyle.class]" id="chateau-details-box" :style="getCommonStyle.style">
            <div class="chateau-details-box">
                <div class="row mx-0 my-0 chateau-details-content">
                    <div class="col-12 col-lg-12 col-md-12 card border-0 px-0 py-1 chateau-details-content-box">
                        <div class="product-main-image">
                            <img v-if="detailsData.mcover_url" :src="'/express_api/' + detailsData.mcover_url"
                                alt="Estate Select">
                        </div>
                    </div>
                </div>
                <div class="chateau-details-html-content common-width-box">
                    <div class="row">
                        <div class="col-6 col-lg-6 col-md-12 chateau-details-html-content-box">
                            <div class="chateau-details-html-content-title">
                                <h2 style="font-size: 2.4em;padding-bottom: 10px;">{{ detailsData.title }}酒庄</h2>
                                <h2 style="font-size: 2.4em">{{ detailsData.english_title }}</h2>
                            </div>
                            <div class="chateau-details-html-content-title" style="padding-top: 20px;">
                                <h2>{{ detailsData.nation }}, {{ detailsData.origin }}</h2>
                                <h2>{{ detailsData.english_nation }}, {{ detailsData.english_origin }}</h2>
                            </div>
                            <div class="chateau-details-html-content-sub-title">
                                <span>
                                    {{ detailsData.suzerain }}
                                </span>
                                <span>酒庄庄主</span>
                            </div>
                            <div class="chateau-details-html-content-sub-title">
                                <span>
                                    WINEMAKER {{ detailsData.english_suzerain }}
                                </span>
                            </div>
                            
                            <div class="chateau-details-html-content-text">
                                <div class="chateau-details-html-content-text-title">
                                    简介
                                </div>
                                <div v-html="detailsData.intro"></div>
                            </div>
                            <div class="row my-3 text-center award-box">
                                <div class="col-3" v-for="(item, index) in medalData" :key="index">
                                    <div>
                                        <img :src="'/express_api/' + item.medal_url"/>
                                    </div>
                                    <div class="my-1" style="color: #470125;">
                                        {{ item.medal_title }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 col-md-12 chateau-details-html-content-img">
                            <div>
                                <img v-if="detailsData.address_url" :src="'/express_api/' + detailsData.address_url" alt="Estate Select"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="home-corp-box home-corp-terroir-box" style="background: #f9f7f4;">
                    <div class="row corp-main-box common-width-box">
                        <div style="background: transparent;" class="col-6 col-lg-6 col-md-12 card border-0 px-0 py-0 my-md-5 home-corp-content-left">
                            <img v-if="detailsData.terroir_url" :src="'/express_api/' + detailsData.terroir_url" />
                        </div>
                        <div style="background: transparent;" class="col-6 col-lg-6 col-md-12 card border-0 px-0 py-0">
                            <div class="home-corp-content-box">
                                <div class="common-subtitle-box" style="text-align: left;">风土特色</div>
                                <div class="home-corp-content-text" v-html="detailsData.terroir">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="home-corp-box">
                    <div class="row corp-main-box common-width-box">
                        <div class="col-6 col-lg-6 col-md-12 card border-0 px-0 py-0">
                            <div class="home-corp-content-box">
                                <div class="common-subtitle-box" style="text-align: left;">庄主故事</div>
                                <div class="home-corp-content-text" v-html="detailsData.story">
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 card col-md-12 border-0 px-0 py-0 my-md-5 home-corp-content-left">
                            <img v-if="detailsData.story_url" :src="'/express_api/' + detailsData.story_url" />
                        </div>
                    </div>
                </div>
                <div class="wine-box">
                    <div class="wine-wrap common-width-box">
                        <div class="common-subtitle-box">{{detailsData.title}}酒庄的红酒</div>
                            <div class="row" v-if="caseData.length" style="padding-bottom: 1.5rem;">
                                <div style="background: transparent" class="col-3 col-md-6 col-lg-3 card border-0 px-0 py-0 my-3" v-for="(item, key) in caseData" :key="key">
                                    <Card :cardData="item" />
                                </div>
                            </div>
                            <div v-else class="none-box">
                                暂无数据
                            </div>
                    </div>
                </div>
                
            </div>
        </div>
    </commonbody>
</template>

<script>
// @ is an alias to /src
import commonbody from '@/components/commonbody.vue';
import Card from "@/components/card.vue";
import * as casesApi from '@/api/cases';
import * as MedalApi from '@/api/medal';
import { format, returnContentType } from '@/utils'
import { mapGetters } from 'vuex';

export default {
    name: "ChateauDetails",
    components: {
        commonbody,
        Card,
    },
    data() {
        return {
            id: "",
            detailsData: {},
            caseData: [],
            medalData: [],
            defaultBg: require('../../public/images/jz1.png'),
        };
    },
    computed: {
        ...mapGetters(['getCommonStyle']),
    },
    created() {
        this.paramsUrl();
    },
    methods: {
        /**
         * @desc 获取时间
         */
        parseTime(string) {
            return format(new Date(string))
        },
        /**
         * @desc 检测页面参数是否完整
         */
        paramsUrl() {
            let query = this.$route.query;

            if (typeof query.id !== 'undefined') {
                this.id = query.id;

                this.selectCasesById();
                this.selectCaseDetailsAll();
                this.selectCaseMedal();
            } else {
                this.$message({
                    message: 'id不存在',
                    type: 'warning'
                })
                this.$router.push({
                    path: "/chateau"
                })
            }
        },
        /**
         * @desc 通过获取详细数据
         */
        selectCasesById() {
            let params = {
                id: this.id
            }
            casesApi.selectCasesById(params).then(res => {
                this.detailsData = res.data || {};
            })
        },
        /**
         * @desc 获取案例数据
         */
        selectCaseDetailsAll() {
            let params = {
                cases_id: this.id,
            };
            casesApi.selectCaseDetailsAll(params).then(res => {
                this.caseData = res.data || [];
            })
        },
        /**
         * @desc 获取案例数据
         */
         selectCaseMedal() {
            let params = {
                case_id: this.id,
            };
            MedalApi.selectData(params).then(res => {
                this.medalData = res.data || [];
            })
            .catch(() => {
                this.medalData = [];
            })
        },
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.chateau-details-header {
    height: 400px;
    width: 100%;
    position: relative;
    background: url('../../public/images/jz1.png') center;
    background-size: cover;

    h2 {    
        font-size: 90px;
        top: 200px;
        left: 25%;
        position: absolute;
        padding-top: 20px;
        padding-right: 40px;
        padding-bottom: 20px;
        padding-left: 40px;
        background-color: rgba(0, 0, 0, 0.41);
        color: #fff;
    }

    img {
        width: 100%;
        max-height: 100%;
    }
}

#chateau-details-box {
    // margin-top: 80px;

    .award-box{
        // padding: 0 10%;
        margin-top: 40px !important;
        img{
            width: 60%;
        }
    }

    .chateau-details-box {
        width: 100%;
        margin: 0 auto;
        // text-align: left;

        .corp-main-box{
            // width: 80%;
            max-width: 1536px;
            margin: 0 auto;
        }
            
        .home-corp-box {
            // height: 600px;
            width: 100%;
            // overflow: hidden;
            text-align: left;
            padding: 100px 0;
            // margin: 60px 0;

            &.home-corp-terroir-box {
                .home-corp-content-left {

                    img {
                        left: 10%;
                        -webkit-box-shadow: -30px 30px 1px 1px rgba(71,1,37,1);
                        -moz-box-shadow: -30px 30px 1px 1px rgba(71,1,37,1);
                        box-shadow: -30px 30px 1px 1px rgba(71,1,37,1);
                    }
                }
            }

            .row {
                min-height: 400px;
            }

            .home-corp-content-left {
                display: flex;
                align-items: center;
                img {
                    width: 80%;
                    max-width: 537px;
                    // position: absolute;
                    // right: 10%;

                    -webkit-box-shadow: 30px 30px 1px 1px rgba(71,1,37,1);
                    -moz-box-shadow: 30px 30px 1px 1px rgba(71,1,37,1);
                    box-shadow: 30px 30px 1px 1px rgba(71,1,37,1);
                }

            }

            .home-corp-content-box {
                // margin-left: 60px;

                .home-corp-content-text {
                    text-indent: 2em;
                    margin: 20px auto 50px;
                    // line-height: 30px;
                    // max-height: 56%;
                    overflow: hidden;
                    color: #470125;
                }
            }
        }

        .wine-box{
            width: 100%;
            background: rgb(249, 247, 244);

            .wine-wrap{
                width: 80%;
                max-width: 1536px;
                margin: 0 auto;
                padding: 80px 0;
            }
        }

        .chateau-details-content {
            display: flex;
            align-items: center;

            .chateau-details-content-box {
                .product-main-image {
                    position: relative;
                    padding: 20px;
                    width: 200px;
                    height: 200px;
                    top: -80px;
                    left: 50%;
                    transform: translate(-50%);

                    img {
                        width: 100%;
                        margin-top: 25%;
                    }
                }

                h2 {
                    color: #470125;
                    padding-bottom: 20px;
                    line-height: 40px;
                }

                .purchase {
                    text-align: left;
                }
            }

        }

        .chateau-details-time {
            margin-bottom: 10px;

            span {
                margin: 0 10px;
            }
        }

        .chateau-details-title {
            font-size: 20px;
            text-align: center;
            margin: 35px auto;
        }

        .chateau-details-html-content {
            width: 80%;
            margin: 0 auto;
            max-width: 1536px;
            min-height: 400px;
            // padding-bottom: 85px;
            // border-top: 1px solid #BFBFBF;
            overflow: hidden;
            padding-bottom: 20px;

            .chateau-details-html-content-img {
                display: flex;
                align-items: center;
            }

            .chateau-details-html-content-box {
                color: #470125;


                .chateau-details-html-content-title {
                    padding-bottom: 20px;

                    h2 {
                        font-size: 1.3em;
                        // line-height: 30px;
                        font-weight: bold;
                    }
                }

                .chateau-details-html-content-sub-title {
                    font-size: 1.2em;
                    // line-height: 30px;
                    // margin-bottom: 10px;
                    font-weight: bold;
                }

                .chateau-details-html-content-text {
                    padding-right: 10%;
                    padding-top: 30px;
                    
                    .chateau-details-html-content-text-title {
                        font-size: 1em;
                        padding-bottom: 10px;
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
#chateau-details-box {
    .chateau-details-html-content {
        text-align: left;
        img {
            max-width: 100%;
            display: block;
            margin: 0 auto;
        }
    }
}
</style>